module.exports = __webpack_public_path__ + "static/media/github.77abe649.svg";